import { fetchData, apiURL } from './api_helper';


const listProducts = () => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}payments/products`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const createSession = (payload) => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}payments/stripe/session`;
    fetchData(endpointURL, 'post', payload).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const getCurrentSubscription = (companyId) => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${companyId}/payments/subscriptions`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const getInvoices = (companyId) => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${companyId}/payments/invoices`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const upgradePlan = ({ companyId, payload }) => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${companyId}/payments/upgrade`;
    fetchData(endpointURL, 'post', payload).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const cancelPlan = ({ companyId, reasonIndex }) => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${companyId}/payments/cancel`;
    fetchData(endpointURL, 'post', { reasonIndex }).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

export default {
    listProducts,
    createSession,
    getCurrentSubscription,
    getInvoices,
    upgradePlan,
    cancelPlan,
};
